import { useState } from "react";
import { faqItems } from "@/mocks/comicGuide";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm font-medium text-primary-700">
            <i className="ri-question-line"></i> 常见问题
          </span>
          <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">关于漫画阅读软件，你关心的都在这里</h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">整理了大家最常问的几个使用问题，帮你快速上手。</p>
        </div>

        <div className="mt-10 space-y-3">
          {faqItems.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-2xl border transition ${
                  isOpen ? "border-primary-200 bg-background-50" : "border-background-200 bg-background-50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="flex items-center gap-3 text-base font-bold text-foreground-950">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-sm text-secondary-900">
                      Q
                    </span>
                    {item.q}
                  </span>
                  <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-xl text-foreground-500`}></i>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4 pl-14">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}